<template>
  <!-- 活动详情页面：活动预览 / 编辑 / 报名观众 -->
  <div class="page-container">
    <div class="page-card">
      <!-- 顶部：返回、标题与操作按钮 -->
      <div class="page-card__header">
        <div class="page-head">
          <el-button size="small" icon="el-icon-back" @click="goList">返回列表</el-button>
          <span class="page-head__title" :title="detail.title">
            {{ detail.title || "活动详情" }}
          </span>
          <el-tag
            v-if="changetype === 1 && !viewMode"
            size="small"
            type="warning"
            effect="plain"
          >
            编辑中
          </el-tag>
          <el-tag
            v-else-if="changetype === 1 && detail.type"
            size="small"
            effect="plain"
            :type="detail.type === '线上' ? 'success' : 'info'"
          >
            {{ detail.type }}
          </el-tag>
        </div>

        <div class="page-head__actions">
          <!-- 同期活动详情：预览态 -->
          <template v-if="changetype === 1 && viewMode">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-edit"
              :disabled="loadingInfo"
              @click="startEdit"
            >
              修改
            </el-button>
            <el-button
              size="small"
              type="danger"
              plain
              icon="el-icon-delete"
              @click="deteleProduct"
            >
              删除
            </el-button>
          </template>

          <!-- 同期活动详情：编辑态 -->
          <template v-else-if="changetype === 1">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-check"
              :loading="saving"
              @click="onBaseSubmit('form')"
            >
              保存修改
            </el-button>
            <el-button size="small" @click="cancelEdit">取消</el-button>
          </template>

          <!-- 报名观众 -->
          <template v-else>
            <el-button
              size="small"
              icon="el-icon-refresh"
              :loading="loadingList"
              @click="loadPage(currentPage)"
            >
              刷新
            </el-button>
            <el-button
              size="small"
              type="primary"
              plain
              icon="el-icon-download"
              @click="exportList"
            >
              导出名单
            </el-button>
          </template>
        </div>
      </div>

      <!-- 选项卡 -->
      <div class="page-card__tabs tab-nav">
        <el-button
          round
          size="small"
          :class="{ 'is-active-tab': changetype === 1 }"
          @click="handleTabChange(1)"
        >
          同期活动详情
        </el-button>
        <el-button
          round
          size="small"
          :class="{ 'is-active-tab': changetype === 2 }"
          @click="handleTabChange(2)"
        >
          活动报名观众
          <span v-if="aSum" class="tab-count">{{ aSum }}</span>
        </el-button>
      </div>

      <!-- ============ 同期活动详情 ============ -->
      <div v-if="changetype === 1" v-loading="loadingInfo" class="page-card__body">
        <!-- 预览态 -->
        <div v-if="viewMode" class="detail">
          <div class="detail__head">
            <el-image
              v-if="detail.logo"
              class="detail__logo"
              :src="imgUrl + detail.logo"
              :preview-src-list="[imgUrl + detail.logo]"
              fit="cover"
            >
              <div slot="error" class="detail__logo-error">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div v-else class="detail__logo detail__logo--empty">
              <i class="el-icon-picture-outline"></i>
              <span>未设置转发封面</span>
            </div>
            <div class="detail__intro">
              <h3 class="detail__title">{{ detail.title || "暂无活动标题" }}</h3>
              <p class="detail__desc">{{ detail.desc || "暂无活动描述" }}</p>
            </div>

            <!-- 统计：贴在标题行的最右侧 -->
            <div class="detail__stats">
              <div class="stat">
                <span class="stat__num">{{ detail.view || 0 }}</span>
                <span class="stat__label">浏览量</span>
              </div>
              <div class="stat">
                <span class="stat__num">{{ detail.praise || 0 }}</span>
                <span class="stat__label">收藏数</span>
              </div>
              <div class="stat">
                <span class="stat__num">{{ detail.share || 0 }}</span>
                <span class="stat__label">转发数</span>
              </div>
              <div class="stat">
                <span class="stat__num">{{ aSum || 0 }}</span>
                <span class="stat__label">报名人数</span>
              </div>
            </div>
          </div>

          <!-- 多嘉宾与单嘉宾是二选一：guest 有数据就只展示多嘉宾，否则展示单嘉宾三件套 -->
          <el-descriptions class="detail__meta" :column="2" border size="medium">
            <template v-if="detailGuest.length">
              <el-descriptions-item label="活动方式" :span="2">
                {{ detail.type || "-" }}
              </el-descriptions-item>
              <el-descriptions-item label="演讲嘉宾" :span="2">
                <div class="guest-view">
                  <div
                    v-for="(g, i) in detailGuest"
                    :key="i"
                    class="guest-view__item"
                  >
                    <div v-if="g.topic" class="guest-view__topic">
                      主题{{ i + 1 }}：{{ g.topic }}
                    </div>
                    <div class="guest-view__host">{{ guestDesc(g) }}</div>
                  </div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="活动时间" :span="2">
                {{ formatTime(detail.start_time) }} 至 {{ formatTime(detail.end_time) }}
              </el-descriptions-item>
              <el-descriptions-item label="活动地址" :span="2">
                {{ detail.address || "-" }}
              </el-descriptions-item>
            </template>
            <template v-else>
              <el-descriptions-item label="活动方式">
                {{ detail.type || "-" }}
              </el-descriptions-item>
              <el-descriptions-item label="演讲嘉宾">
                {{ detail.host || "-" }}
              </el-descriptions-item>
              <el-descriptions-item label="职位">
                {{ detail.position || "-" }}
              </el-descriptions-item>
              <el-descriptions-item label="公司名">
                {{ detail.company || "-" }}
              </el-descriptions-item>
              <el-descriptions-item label="活动时间" :span="2">
                {{ formatTime(detail.start_time) }} 至 {{ formatTime(detail.end_time) }}
              </el-descriptions-item>
              <el-descriptions-item label="活动地址" :span="2">
                {{ detail.address || "-" }}
              </el-descriptions-item>
            </template>
          </el-descriptions>

          <div class="detail__section-title">活动内容</div>
          <div v-if="detail.info" class="detail__content ql-editor" v-html="detail.info"></div>
          <div v-else class="detail__empty">暂无活动内容</div>
        </div>

        <!-- 编辑态 -->
        <el-form
          v-else
          ref="form"
          class="edit-form"
          :model="form"
          :rules="rules"
          label-width="90px"
        >
          <div class="form-section-title">转发封面</div>
          <el-form-item prop="logo" label-width="0">
            <div class="logo-editor">
              <el-upload
                class="logo-uploader"
                :action="imagesrc"
                :show-file-list="false"
                :headers="headers"
                accept="image/*"
                :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess"
                :on-error="handleAvatarError"
              >
                <div v-loading="uploadingLogo" class="logo-box">
                  <img v-if="form.logo" :src="imgUrl + form.logo" alt="转发封面" />
                  <i v-else class="el-icon-plus"></i>
                  <div class="logo-box__mask">
                    {{ form.logo ? "点击更换" : "点击上传" }}
                  </div>
                </div>
              </el-upload>
              <div class="logo-tips">
                <p class="logo-tips__line">最佳展示尺寸：5:4，建议 500 x 400 像素</p>
                <p class="logo-tips__line">该图片将作为活动分享转发时的封面图</p>
                <p class="logo-tips__line">支持 JPG / PNG / GIF，单张不超过 10MB</p>
                <el-button
                  v-if="form.logo"
                  type="text"
                  class="action-btn--danger"
                  @click="removeLogo"
                >
                  移除封面
                </el-button>
              </div>
            </div>
          </el-form-item>

          <div class="form-section-title">基础信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="活动标题" prop="title">
                <el-input v-model="form.title" clearable placeholder="请输入活动标题"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动方式" prop="type">
                <el-radio-group v-model="form.type">
                  <el-radio label="线上">线上</el-radio>
                  <el-radio label="线下">线下</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="嘉宾设置" prop="guestMode" label-width="90px">
                <el-radio-group v-model="form.guestMode">
                  <el-radio-button label="single">单个演讲嘉宾</el-radio-button>
                  <el-radio-button label="multi">多位演讲嘉宾</el-radio-button>
                </el-radio-group>
                <span class="guest-mode-tip">
                  两种方式二选一：填了多嘉宾后，单个嘉宾的姓名 / 职位 / 公司名会被清空
                </span>
              </el-form-item>
            </el-col>

            <!-- 单个嘉宾 -->
            <template v-if="form.guestMode === 'single'">
              <el-col :span="12">
                <el-form-item label="演讲嘉宾" prop="host">
                  <el-input v-model="form.host" clearable placeholder="请输入演讲嘉宾"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职位" prop="position">
                  <el-input v-model="form.position" clearable placeholder="请输入演讲嘉宾职位"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="公司名" prop="company">
                  <el-input v-model="form.company" clearable placeholder="请输入公司名"></el-input>
                </el-form-item>
              </el-col>
            </template>

            <!-- 多位嘉宾：guest 存 JSON 数组，字段与小程序端一致 -->
            <el-col v-else :span="24">
              <el-form-item label="演讲嘉宾" prop="guestList">
                <div class="guest-editor">
                  <div
                    v-for="(g, i) in form.guestList"
                    :key="i"
                    class="guest-row"
                  >
                    <div class="guest-row__head">
                      <span class="guest-row__idx">嘉宾 {{ i + 1 }}</span>
                      <el-button
                        type="text"
                        class="action-btn--danger"
                        @click="removeGuest(i)"
                      >
                        删除
                      </el-button>
                    </div>
                    <el-row :gutter="12">
                      <el-col :span="12">
                        <el-input v-model="g.topic" placeholder="主讲主题（选填）"></el-input>
                      </el-col>
                      <el-col :span="12">
                        <el-input v-model="g.host" placeholder="嘉宾姓名（必填）"></el-input>
                      </el-col>
                      <el-col :span="12">
                        <el-input v-model="g.company" placeholder="单位（选填）"></el-input>
                      </el-col>
                      <el-col :span="12">
                        <el-input v-model="g.position" placeholder="职位（选填）"></el-input>
                      </el-col>
                    </el-row>
                  </div>
                  <el-button size="small" icon="el-icon-plus" @click="addGuest">
                    添加一位嘉宾
                  </el-button>
                  <p class="guest-editor__tip">
                    嘉宾姓名必填；单位与职位会拼成「单位职位 姓名」展示，与小程序一致
                  </p>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="活动描述" prop="desc">
                <el-input
                  v-model="form.desc"
                  type="textarea"
                  :rows="2"
                  placeholder="一句话说明活动亮点，将展示在活动列表和详情页"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="form-section-title">时间与地点</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="开始时间" prop="start_time">
                <el-date-picker
                  v-model="form.start_time"
                  type="datetime"
                  placeholder="请选择开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间" prop="end_time">
                <el-date-picker
                  v-model="form.end_time"
                  type="datetime"
                  placeholder="请选择结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="活动地址" prop="address">
                <el-input
                  v-model="form.address"
                  clearable
                  placeholder="请输入活动地址，线下活动请填写详细地址"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="form-section-title">活动内容</div>
          <el-form-item prop="info" label-width="0">
            <tiny-editor v-model="form.info" :init="init" id="textarea"></tiny-editor>
          </el-form-item>

          <div class="form-actions-bar">
            <el-button type="primary" :loading="saving" @click="onBaseSubmit('form')">
              保存修改
            </el-button>
            <el-button @click="cancelEdit">取消</el-button>
            <span class="form-actions-bar__tip">修改后需点击「保存修改」才会生效</span>
          </div>
        </el-form>
      </div>

      <!-- ============ 活动报名观众 ============ -->
      <div v-else v-loading="loadingList" class="page-card__body">
        <div class="list-summary">
          共 <b>{{ aSum }}</b> 条报名记录
        </div>

        <el-table :data="tableData" style="width: 100%" empty-text="暂无报名观众">
          <el-table-column type="index" label="序号" width="70" :index="indexMethod">
          </el-table-column>
          <el-table-column
            prop="wx_user_detail.name"
            label="姓名"
            min-width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="wx_user_detail.company"
            label="所属公司"
            min-width="180"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="wx_user_detail.phone_number"
            label="联系电话"
            width="140"
          >
          </el-table-column>
          <el-table-column
            prop="wx_user_detail.position"
            label="职位"
            width="130"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="报名日期" width="170">
            <template slot-scope="scope">
              {{ formatTime(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="140">
            <template slot-scope="scope">
              <el-button type="text" @click="handleClick(scope.row)">查看</el-button>
              <el-button
                type="text"
                class="action-btn--danger"
                @click="delete_u(scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrap">
          <el-pagination
            background
            :total="aSum"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            layout="total, prev, pager, next, jumper"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import editor from "@tinymce/tinymce-vue";
  import api from "../../utils/api";
  import { VueEditor } from "vue2-editor";

  /** 表格导出的表头 */
  var EXPORT_HEADER = ["序号", "姓名", "所属公司", "联系电话", "职位", "报名日期"];
  /** 单次导出拉取的最大条数 */
  var EXPORT_SIZE = 1000;
  /** 一行空嘉宾，用于新增和兜底 */
  var EMPTY_GUEST = function () {
    return { topic: "", host: "", company: "", position: "" };
  };

  /**
   * guest 字段存的是 JSON 字符串：[{ topic, host, company, position }]
   * 与小程序端 pages/activity/detail.js 的 parseGuest 保持一致：
   * 解析失败一律当空数组，避免脏数据把页面打挂。
   */
  function parseGuest(guest) {
    if (!guest) {
      return [];
    }
    if (typeof guest === "string") {
      try {
        var list = JSON.parse(guest);
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    }
    return Array.isArray(guest) ? guest : [];
  }

  /** 把 guest 数组规整成固定字段，避免缺 key 时 v-model 取不到值 */
  function normalizeGuestList(list) {
    return (list || []).map(function (g) {
      var item = g || {};
      return {
        topic: item.topic || "",
        host: item.host || "",
        company: item.company || "",
        position: item.position || "",
      };
    });
  }

  export default {
    name: "activityDatail",
    data() {
      // 单个嘉宾（姓名 / 职位 / 公司名）与多嘉宾是二选一，
      // 多嘉宾模式下这三个字段被隐藏，需要跳过必填校验，否则会卡住提交
      var singleGuestRule = (message) => (rule, value, callback) => {
        if (this.form.guestMode === "multi") {
          callback();
          return;
        }
        if (!value) {
          callback(new Error(message));
          return;
        }
        callback();
      };
      return {
        init: {
          // 编辑器配置信息
          selector: "#textarea",
          height: 550,
          language_url: "/static/tinymce/langs/zh-Hans.js",
          language: "zh-Hans",
          menubar: true,
          image_dimensions: false,
          images_upload_url:
            "https://cloudexhibition.chinafastenerinfo.com/api/admin/uploadfile/news/",
          images_upload_base_path:
            "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",

          plugins: [
            "advlist autolink lists link image imagetools charmap print preview anchor textcolor imageupload",
            "searchreplace visualblocks code fullscreen ",
            "insertdatetime media table contextmenu paste code help wordcount",
          ],
          toolbar:
            "preview link code insertdatetime  charmap | media  image | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | help",
          automatic_uploads: true,
          images_upload_handler: function (blobInfo, succFun, failFun) {
            var xhr, formData;
            var file = blobInfo.blob();
            xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.open(
              "POST",
              "https://cloudexhibition.chinafastenerinfo.com/api/admin/uploadfile/news/"
            );

            xhr.setRequestHeader(
              "Authorization",
              "JWT " + localStorage.getItem("adminToken")
            );
            xhr.setRequestHeader("XMLHttpRequest", "HeaderValue");

            xhr.onload = function () {
              var json;
              if (xhr.status != 200) {
                failFun("HTTP Error: " + xhr.status);
                return;
              }
              json = JSON.parse(xhr.responseText);
              succFun(
                "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/" +
                json.filename
              );
            };
            formData = new FormData();
            formData.append("file", file, file.name);
            xhr.send(formData);
          },
        },
        id: "",
        /** 1 = 同期活动详情，2 = 活动报名观众 */
        changetype: 1,
        /** true = 预览态，false = 编辑态 */
        viewMode: true,
        /** 预览展示用的服务端原始数据 */
        detail: {},
        /** 编辑用表单（字段与 PATCH 提交字段一一对应） */
        form: {
          logo: "",
          title: "",
          type: "",
          company: "",
          position: "",
          address: "",
          desc: "",
          host: "",
          info: "",
          start_time: "",
          end_time: "",
          /** guest 原始 JSON 字符串，仅用于快照比对 */
          guest: "",
          /** single = 单个嘉宾，multi = 多嘉宾 */
          guestMode: "single",
          /** 多嘉宾列表，提交时序列化成 guest */
          guestList: [],
        },
        /** 进入编辑态时的表单快照，用于判断是否有未保存修改 */
        snapshot: "",
        rules: {
          title: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
          type: [{ required: true, message: "请选择活动方式", trigger: "change" }],
          company: [{ trigger: "blur", validator: singleGuestRule("请输入公司名") }],
          position: [{ trigger: "blur", validator: singleGuestRule("请输入职位") }],
          desc: [{ required: true, message: "请输入活动描述", trigger: "blur" }],
          host: [
            { trigger: "blur", validator: singleGuestRule("请输入演讲嘉宾") },
          ],
          guestList: [
            {
              trigger: "change",
              validator: (rule, value, callback) => {
                if (this.form.guestMode !== "multi") {
                  callback();
                  return;
                }
                var list = (this.form.guestList || []).filter(function (g) {
                  return (g.topic || g.host || g.company || g.position || "").trim();
                });
                if (!list.length) {
                  callback(new Error("请至少添加一位演讲嘉宾"));
                  return;
                }
                for (var i = 0; i < list.length; i++) {
                  if (!(list[i].host || "").trim()) {
                    callback(new Error("第 " + (i + 1) + " 位嘉宾请填写姓名"));
                    return;
                  }
                }
                callback();
              },
            },
          ],
          info: [{ required: true, message: "请输入活动内容", trigger: "blur" }],
          address: [{ required: true, message: "请输入活动地址", trigger: "blur" }],
          start_time: [
            { required: true, message: "请选择开始时间", trigger: "change" },
          ],
          end_time: [
            {
              required: true,
              trigger: "change",
              validator: (rule, value, callback) => {
                if (!value) {
                  callback(new Error("请选择结束时间"));
                  return;
                }
                if (this.form.start_time && value < this.form.start_time) {
                  callback(new Error("结束时间不能早于开始时间"));
                  return;
                }
                callback();
              },
            },
          ],
        },
        // 加载状态
        loadingInfo: false,
        loadingList: false,
        saving: false,
        uploadingLogo: false,
        /** 富文本初始化后刷新快照用的定时器 */
        editorSnapshotTimer: null,
        // 报名观众列表
        tableData: [],
        aSum: 0,
        currentPage: 1,
        pagesize: 10,
        // 上传与图片地址
        headers: {
          Authorization: "JWT " + localStorage.getItem("adminToken"),
        },
        imagesrc: this.baseUrl + "/admin/uploadfile/activity/",
        imgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/activity/",
        newimgUrl: "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/news/",
      };
    },
    mounted() {
      // 初始化加载活动信息和报名用户列表
      this.id = this.$route.query.id;
      this.activityInfo();
      this.getUserList();
    },
    computed: {
      /** 编辑态下表单是否被改动过 */
      isDirty() {
        return this.viewMode ? false : JSON.stringify(this.form) !== this.snapshot;
      },
      /** 预览态的多嘉宾列表（guest 是 JSON 字符串，这里解析） */
      detailGuest() {
        return normalizeGuestList(parseGuest(this.detail.guest)).filter(
          function (g) {
            return g.topic || g.host || g.company || g.position;
          }
        );
      },
    },
    methods: {
      /* ---------------- 数据加载 ---------------- */

      /** 获取活动详情，silent 为 true 时不显示骨架加载态 */
      activityInfo(silent) {
        if (!this.id) {
          this.$message.error("缺少活动 ID，请从活动列表重新进入");
          return;
        }
        if (!silent) {
          this.loadingInfo = true;
        }
        var url = this.baseUrl + "/admin/activitys/" + this.id + "/";
        api
          .fetchData(url)
          .then((res) => {
            this.detail = res || {};
            this.buildForm(this.detail);
          })
          .catch(() => {
            this.$message.error("活动信息加载失败，请刷新重试");
          })
          .then(() => {
            this.loadingInfo = false;
          });
      },

      /** 用服务端数据填充表单，并记录快照 */
      buildForm(source) {
        var data = source || {};
        var guests = normalizeGuestList(parseGuest(data.guest));
        this.form = {
          logo: data.logo || "",
          title: data.title || "",
          type: data.type || "",
          company: data.company || "",
          position: data.position || "",
          address: data.address || "",
          desc: data.desc || "",
          host: data.host || "",
          info: data.info || "",
          start_time: this.toPickerTime(data.start_time),
          end_time: this.toPickerTime(data.end_time),
          guest: data.guest || "",
          // 有 guest 数据就直接进多嘉宾模式，两种填法互斥
          guestMode: guests.length ? "multi" : "single",
          guestList: guests.length ? guests : [EMPTY_GUEST()],
        };
        this.snapshot = JSON.stringify(this.form);
        this.viewMode = true;
      },

      /** 获取活动报名用户列表（第 1 页） */
      getUserList() {
        this.loadPage(1);
      },

      /** 加载报名观众指定页 */
      loadPage(page) {
        if (!this.id) {
          return;
        }
        var p = page || 1;
        this.loadingList = true;
        var url =
          this.baseUrl +
          "/admin/activity_registers/?activity=" +
          this.id +
          "&ordering=-create_time&page=" +
          p;
        api
          .fetchData(url)
          .then((res) => {
            this.tableData = (res && res.results) || [];
            this.aSum = (res && res.count) || 0;
            this.currentPage = p;
          })
          .catch(() => {
            this.$message.error("报名观众加载失败，请刷新重试");
          })
          .then(() => {
            this.loadingList = false;
          });
      },

      /* ---------------- 视图切换 ---------------- */

      /** 切换选项卡，编辑态有未保存修改时先确认 */
      handleTabChange(type) {
        if (type === this.changetype) {
          return;
        }
        if (this.changetype === 1 && !this.viewMode && this.isDirty) {
          this.$confirm("当前有未保存的修改，切换后将丢失，是否继续？", "提示", {
            confirmButtonText: "放弃修改",
            cancelButtonText: "继续编辑",
            type: "warning",
          })
            .then(() => {
              this.buildForm(this.detail);
              this.changetype = type;
            })
            .catch(() => {});
          return;
        }
        this.changetype = type;
      },

      /** 进入编辑态 */
      startEdit() {
        this.buildForm(this.detail);
        this.viewMode = false;
        this.syncEditorSnapshot();
      },

      /**
       * 富文本编辑器初始化时会调用 setContent，触发 change 并把规范化后的 HTML 写回 v-model，
       * 容易让"未保存修改"误报。这里在初始化结束后刷新一次快照，
       * 且仅当差异只存在于富文本内容时才刷新，避免掩盖用户真实改动。
       */
      syncEditorSnapshot() {
        var self = this;
        clearTimeout(this.editorSnapshotTimer);
        this.editorSnapshotTimer = setTimeout(function () {
          if (self.viewMode) {
            return;
          }
          var currentFields = Object.assign({}, self.form);
          var baselineFields = null;
          try {
            baselineFields = JSON.parse(self.snapshot);
          } catch (e) {
            baselineFields = null;
          }
          if (!baselineFields) {
            return;
          }
          delete currentFields.info;
          delete baselineFields.info;
          if (JSON.stringify(currentFields) === JSON.stringify(baselineFields)) {
            self.snapshot = JSON.stringify(self.form);
          }
        }, 1500);
      },

      /** 取消编辑，回到预览态 */
      cancelEdit() {
        clearTimeout(this.editorSnapshotTimer);
        if (this.isDirty) {
          this.$confirm("确定放弃未保存的修改吗？", "提示", {
            confirmButtonText: "放弃修改",
            cancelButtonText: "继续编辑",
            type: "warning",
          })
            .then(() => {
              this.buildForm(this.detail);
            })
            .catch(() => {});
          return;
        }
        this.buildForm(this.detail);
      },

      /** 分页切换 */
      handleCurrentChange(val) {
        this.loadPage(val);
      },

      /** 表格序号跨页连续 */
      indexMethod(index) {
        return (this.currentPage - 1) * this.pagesize + index + 1;
      },

      /* ---------------- 多嘉宾 ---------------- */

      /** 追加一位空嘉宾 */
      addGuest() {
        this.form.guestList.push(EMPTY_GUEST());
      },

      /** 删除第 index 位嘉宾，至少保留一行 */
      removeGuest(index) {
        this.form.guestList.splice(index, 1);
        if (!this.form.guestList.length) {
          this.form.guestList.push(EMPTY_GUEST());
        }
      },

      /**
       * 单行嘉宾文案：「单位职位 姓名」（连写，中间不加分隔符）
       * 与小程序 utils/activity.wxs 的 guestDesc 保持一致
       */
      guestDesc(g) {
        var item = g || {};
        var org = (item.company || "") + (item.position || "");
        if (!org) {
          return item.host || "";
        }
        if (!item.host) {
          return org;
        }
        return org + " " + item.host;
      },

      /** 提交前序列化多嘉宾，剔除整行空白的占位行 */
      buildGuestPayload() {
        return (this.form.guestList || []).reduce(function (acc, g) {
          var row = {
            topic: (g.topic || "").trim(),
            host: (g.host || "").trim(),
            company: (g.company || "").trim(),
            position: (g.position || "").trim(),
          };
          if (row.topic || row.host || row.company || row.position) {
            acc.push(row);
          }
          return acc;
        }, []);
      },

      /* ---------------- 保存与删除 ---------------- */

      /** 提交修改活动信息 */
      onBaseSubmit(formname) {
        this.$refs[formname].validate((valid) => {
          if (!valid) {
            this.$message.warning("请先补全带 * 的必填项");
            return;
          }
          this.saving = true;
          var isMulti = this.form.guestMode === "multi";
          var guests = isMulti ? this.buildGuestPayload() : [];
          var url = this.baseUrl + "/admin/activitys/" + this.id + "/";
          api
            .patchData(url, {
              title: this.form.title,
              type: this.form.type,
              address: this.form.address,
              desc: this.form.desc,
              logo: this.form.logo,
              // 两种填法二选一：多嘉宾模式把单嘉宾三个字段清空，避免两边数据打架
              company: isMulti ? "" : this.form.company,
              position: isMulti ? "" : this.form.position,
              host: isMulti ? "" : this.form.host,
              guest: guests.length ? JSON.stringify(guests) : "",
              info: this.form.info,
              start_time: this.form.start_time,
              end_time: this.form.end_time,
            })
            .then(() => {
              this.$message.success("修改活动成功");
              this.viewMode = true;
              // 重新拉取服务端数据，保证预览展示的是最新内容
              this.activityInfo(true);
            })
            .catch(() => {
              this.$message.error("保存失败，请稍后重试");
            })
            .then(() => {
              this.saving = false;
            });
        });
      },

      /** 删除活动 */
      deteleProduct() {
        this.$confirm(
          "删除后该活动及其报名记录将无法恢复，是否继续？",
          "删除活动",
          {
            confirmButtonText: "确定删除",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          var url = this.baseUrl + "/admin/activitys/" + this.id + "/";
          api
            .deleteData(url)
            .then(() => {
              this.$message.success("删除成功");
              this.goList();
            })
            .catch(() => {
              this.$message.error("删除失败，请稍后重试");
            });
        }).catch(() => {});
      },

      /** 删除报名观众 */
      delete_u(row) {
        this.$confirm("将删除此条报名信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var url = this.baseUrl + "/admin/activity_registers/" + row.id + "/";
          this.loadingList = true;
          api
            .deleteData(url)
            .then(() => {
              this.$message.success("删除成功");
              // 删掉当前页最后一条时自动回退一页，避免停留在空页
              var page = this.currentPage;
              if (this.tableData.length === 1 && page > 1) {
                page = page - 1;
              }
              this.loadPage(page);
            })
            .catch(() => {
              this.loadingList = false;
              this.$message.error("删除失败，请稍后重试");
            });
        }).catch(() => {});
      },

      /* ---------------- 报名名单导出 ---------------- */

      /** 导出当前活动的全部报名名单为 CSV */
      exportList() {
        if (!this.aSum) {
          this.$message.info("当前活动暂无报名记录");
          return;
        }
        this.$confirm(
          "将导出全部 " + this.aSum + " 条报名记录为 CSV 文件，是否继续？",
          "导出名单",
          { confirmButtonText: "导出", cancelButtonText: "取消" }
        ).then(() => {
          var url =
            this.baseUrl +
            "/admin/activity_registers/?activity=" +
            this.id +
            "&ordering=-create_time&size=" +
            EXPORT_SIZE;
          this.loadingList = true;
          api
            .fetchData(url)
            .then((res) => {
              var rows = (res && res.results) || [];
              var total = (res && res.count) || rows.length;
              var lines = [EXPORT_HEADER.join(",")];
              rows.forEach((row, i) => {
                var user = row.wx_user_detail || {};
                lines.push(
                  [
                    i + 1,
                    user.name,
                    user.company,
                    user.phone_number,
                    user.position,
                    this.formatTime(row.create_time),
                  ]
                    .map((cell) => this.csvCell(cell))
                    .join(",")
                );
              });
              this.downloadCsv(
                (this.detail.title || "活动") + "_报名名单.csv",
                lines.join("\r\n")
              );
              if (total > rows.length) {
                this.$message.warning(
                  "接口最多返回 " + rows.length + " 条，本次导出可能不完整"
                );
              } else {
                this.$message.success("已导出 " + rows.length + " 条报名记录");
              }
            })
            .catch(() => {
              this.$message.error("导出失败，请稍后重试");
            })
            .then(() => {
              this.loadingList = false;
            });
        }).catch(() => {});
      },

      /** CSV 单元格转义 */
      csvCell(value) {
        return '"' + String(value == null ? "" : value).replace(/"/g, '""') + '"';
      },

      /** 触发浏览器下载（加 BOM 保证 Excel 正确识别中文） */
      downloadCsv(filename, content) {
        var blob = new Blob(["\uFEFF" + content], {
          type: "text/csv;charset=utf-8;",
        });
        var link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      },

      /* ---------------- 图片上传 ---------------- */

      /** 图片上传成功回调 */
      handleAvatarSuccess(res) {
        this.uploadingLogo = false;
        if (res && res.filename) {
          this.form.logo = res.filename;
          this.$message.success("转发封面上传成功，保存后生效");
        } else {
          this.$message.error("转发封面上传失败，请重试");
        }
      },

      /** 图片上传失败回调 */
      handleAvatarError() {
        this.uploadingLogo = false;
        this.$message.error("转发封面上传失败，请检查网络或登录状态");
      },

      /** 图片上传前校验 */
      beforeAvatarUpload(file) {
        var okType = /^image\/(jpeg|jpg|png|gif|bmp|webp)$/.test(file.type);
        if (!okType) {
          this.$message.error("仅支持 JPG / PNG / GIF / BMP / WEBP 格式的图片");
          return false;
        }
        if (file.size / 1024 / 1024 > 10) {
          this.$message.error("图片大小不能超过 10MB");
          return false;
        }
        this.uploadingLogo = true;
        return true;
      },

      /** 移除转发封面 */
      removeLogo() {
        this.$confirm("移除后需点击「保存修改」才会生效，是否继续？", "提示", {
          confirmButtonText: "确定移除",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.form.logo = "";
        }).catch(() => {});
      },

      /* ---------------- 工具方法 ---------------- */

      /** 兼容 IOS 微秒位数的 Date 解析 */
      parseDate(value) {
        if (!value) {
          return null;
        }
        if (value instanceof Date) {
          return value;
        }
        var text = String(value).replace(/(\.\d{3})\d+/, "$1");
        var date = new Date(text);
        return isNaN(date.getTime()) ? null : date;
      },

      /** 格式化为 yyyy-MM-dd HH:mm */
      formatTime(value) {
        var date = this.parseDate(value);
        if (!date) {
          return "-";
        }
        var pad = function (n) {
          return (n < 10 ? "0" : "") + n;
        };
        return (
          date.getFullYear() +
          "-" +
          pad(date.getMonth() + 1) +
          "-" +
          pad(date.getDate()) +
          " " +
          pad(date.getHours()) +
          ":" +
          pad(date.getMinutes())
        );
      },

      /** 转换为日期选择器需要的 yyyy-MM-dd HH:mm:ss 字符串 */
      toPickerTime(value) {
        var date = this.parseDate(value);
        if (!date) {
          return "";
        }
        return (
          this.formatTime(date) +
          ":" +
          (date.getSeconds() < 10 ? "0" : "") +
          date.getSeconds()
        );
      },

      /** 跳转到观众详情页 */
      handleClick(row) {
        this.$router.push({ name: "admin_viewerDetail", query: { id: row.id } });
      },

      /** 返回活动列表页 */
      goList() {
        this.$router.push({ name: "admin_activityList" });
      },
    },
    components: {
      VueEditor,
      "tiny-editor": editor,
    },
    beforeDestroy() {
      clearTimeout(this.editorSnapshotTimer);
    },
    /** 编辑态有未保存修改时，离开页面前提醒 */
    beforeRouteLeave(to, from, next) {
      if (!this.viewMode && this.isDirty) {
        this.$confirm("当前有未保存的修改，离开后将丢失，是否继续？", "提示", {
          confirmButtonText: "放弃修改并离开",
          cancelButtonText: "继续编辑",
          type: "warning",
        })
          .then(() => {
            next();
          })
          .catch(() => {
            next(false);
          });
        return;
      }
      next();
    },
  };
</script>

<style scoped>
  /* ===== 顶部标题区 ===== */
  .page-head {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .page-head__title {
    max-width: 420px;
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .page-head__actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  /* ===== 选项卡 ===== */
  .page-card__tabs {
    display: flex;
    align-items: center;
    padding: 14px var(--spacing-lg);
    border-bottom: 1px solid var(--border-color);
  }

  .tab-count {
    display: inline-block;
    min-width: 18px;
    padding: 0 5px;
    margin-left: 4px;
    font-size: 12px;
    line-height: 16px;
    border-radius: 9px;
    background: var(--color-primary-light);
    color: var(--color-primary);
  }

  .tab-nav .el-button.is-active-tab .tab-count {
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
  }

  /* ===== 预览态 ===== */
  .detail__head {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
  }

  /* 转发封面：5:4 */
  .detail__logo {
    width: 150px;
    height: 120px;
    flex-shrink: 0;
    border: 1px solid var(--border-color);
    border-radius: var(--radius-md);
    background: var(--border-color-light);
  }

  .detail__logo-error {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 24px;
    color: var(--text-muted);
  }

  /* 未设置转发封面时的占位 */
  .detail__logo--empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    line-height: 18px;
    color: var(--text-muted);
    border-style: dashed;
  }

  .detail__logo--empty i {
    font-size: 22px;
  }

  .detail__intro {
    flex: 1;
    min-width: 0;
  }

  .detail__title {
    margin: 0 0 10px;
    font-size: 20px;
    line-height: 30px;
    color: var(--text-primary);
  }

  .detail__desc {
    margin: 0;
    font-size: 14px;
    line-height: 26px;
    color: var(--text-secondary);
  }

  .detail__section-title {
    margin: 24px 0 12px;
    padding-left: 10px;
    font-size: 15px;
    font-weight: 600;
    line-height: 18px;
    color: var(--text-primary);
    border-left: 3px solid var(--color-primary);
  }

  .detail__content {
    font-size: 14px;
    line-height: 26px;
    color: var(--text-primary);
    word-break: break-word;
  }

  .detail__content img {
    max-width: 100%;
    height: auto;
  }

  .detail__empty {
    padding: 24px;
    font-size: 14px;
    text-align: center;
    color: var(--text-muted);
    background: var(--border-color-light);
    border-radius: var(--radius-md);
  }

  /* 统计块：贴标题行最右侧，2 x 2 排列 */
  .detail__stats {
    display: grid;
    flex-shrink: 0;
    grid-template-columns: repeat(2, minmax(88px, 1fr));
    gap: 8px;
    margin-left: auto;
    padding-left: 20px;
    border-left: 1px dashed var(--border-color);
  }

  .stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 0;
    padding: 8px 12px;
    background: var(--border-color-light);
    border-radius: var(--radius-md);
  }

  .stat__num {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    color: var(--color-primary);
  }

  .stat__label {
    font-size: 12px;
    line-height: 20px;
    color: var(--text-secondary);
  }

  /* ===== 编辑态 ===== */
  .form-section-title {
    margin: 0 0 18px;
    padding-bottom: 8px;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    border-bottom: 1px solid var(--border-color-light);
  }

  .form-section-title ~ .form-section-title {
    margin-top: 12px;
  }

  .logo-editor {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .logo-box {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 120px;
    overflow: hidden;
    cursor: pointer;
    background: var(--border-color-light);
    border: 1px dashed var(--border-color);
    border-radius: var(--radius-md);
    transition: border-color 0.2s;
  }

  .logo-box:hover {
    border-color: var(--color-primary);
  }

  .logo-box img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .logo-box i {
    font-size: 26px;
    color: var(--text-muted);
  }

  .logo-box__mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 26px;
    font-size: 12px;
    line-height: 26px;
    text-align: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    transition: opacity 0.2s;
  }

  .logo-box:hover .logo-box__mask {
    opacity: 1;
  }

  .logo-tips__line {
    margin: 0;
    font-size: 12px;
    line-height: 22px;
    color: var(--text-muted);
  }

  .form-actions-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
    padding-top: 20px;
    border-top: 1px solid var(--border-color);
  }

  .form-actions-bar__tip {
    font-size: 12px;
    color: var(--text-muted);
  }

  /* ===== 多嘉宾 ===== */
  .guest-mode-tip {
    margin-left: 12px;
    font-size: 12px;
    color: var(--text-muted);
  }

  .guest-editor {
    width: 100%;
  }

  .guest-row {
    padding: 12px 12px 2px;
    background: var(--border-color-light);
    border: 1px solid var(--border-color-light);
    border-radius: var(--radius-md);
  }

  .guest-row + .guest-row {
    margin-top: 10px;
  }

  .guest-row__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .guest-row__idx {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-secondary);
  }

  .guest-row .el-col {
    margin-bottom: 10px;
  }

  .guest-editor__tip {
    margin: 8px 0 0;
    font-size: 12px;
    line-height: 20px;
    color: var(--text-muted);
  }

  /* 预览态多嘉宾列表 */
  .guest-view__item + .guest-view__item {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px dashed var(--border-color);
  }

  .guest-view__topic {
    color: var(--text-primary);
  }

  .guest-view__host {
    color: var(--text-secondary);
  }

  /* ===== 报名观众列表 ===== */
  .list-summary {
    margin-bottom: 12px;
    font-size: 14px;
    color: var(--text-secondary);
  }

  .list-summary b {
    color: var(--color-primary);
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/activityDatail.vue